import slideStyle from "./InfoPage.module.scss";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { useContext } from "react";
import { getMessage, MessageContext, Message } from "@messageformat/react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.rapidshopAI.subtitle" />}
        title={<Message id="infoPages.rapidshopAI.title" />}
        attachStars
      />

      <div className={slideStyle.section} style={{ marginTop: "5px" }}>
        <div className={slideStyle.heading}>
          <h1 dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.rapidshopAI.description1Title"
            )(),
          }} />
        </div>

        <p
          style={{ textAlign: "center" }}
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.rapidshopAI.description1"
            )(),
          }}
        />

        <div className={slideStyle.heading}>
          <h1>
            <Message id="infoPages.rapidshopAI.features.titles.title" />
          </h1>
        </div>

        <p
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.rapidshopAI.features.titles.description"
            )(),
          }}
        />

        <div className={slideStyle.heading}>
          <h1>
            <Message id="infoPages.rapidshopAI.features.aiAgents.title" />
          </h1>
        </div>

        <p
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.rapidshopAI.features.aiAgents.description"
            )(),
          }}
        />

        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
